const messages = {
    accountBox: {
        title: "Kontrolna tabla",
        description: "Brzo pratite svoje promocije i poene.",
        button: "OTVORI KONTROLNU TABLU",
    },
};

export default {
    messages,
};
